import _styled from "styled-components";
import { variantMap } from './skeleton-loading.constants';
import { loadingText } from './skeleton-loading.components';
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SkeletonLoading = function SkeletonLoading(_ref) {
  var variant = _ref.variant,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? true : _ref$animation;
  return /*#__PURE__*/_jsxs(Wrapper, {
    animation: animation,
    children: [variantMap[variant], loadingText]
  });
};
export default SkeletonLoading;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "skeleton-loading__Wrapper",
  componentId: "sc-3dq1ld-0"
})(["", ";", ""], function (_ref2) {
  var animation = _ref2.animation;
  return animation ? {
    "@keyframes pulse": {
      "50%": {
        "opacity": ".5"
      }
    },
    "animation": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
  } : {};
}, {
  "width": "100%"
});

export * from './skeleton-loading.components';
export * from './skeleton-element-loading';